const chaseAlretData = [
  {
    day: 1,
  },
  {
    day: 3,
  },
  {
    day: 7,
  },
  {
    day: 10,
  },
  {
    day: 14,
  },
  {
    day: 21,
  },
];

export { chaseAlretData };
